import { ServerEvent } from "@/common/notification";
import { AppCacheActions, CacheKey, useAppCacheStore } from "@/common/stores/persistingStores/app";
import {
	NavigationActions,
	TabType,
	useNavigationStore,
} from "@/common/stores/persistingStores/navigation";
import { notificationListener } from "@/hooks/notification";
import { InteractionDto } from "@/repository/models";
import { useMessage } from "@/common/messages";
import { useIntl } from "react-intl";

export const useVoicemailSessionManager = () => {
	const setSelectedTab = useNavigationStore(
		(state: NavigationActions) => state.setSelectedTab
	);
	const appStoreActions = useAppCacheStore((state: AppCacheActions) => state);
	const { show: showMessage } = useMessage();
	const intl = useIntl();

	notificationListener(
		ServerEvent.VoicemailPickedUp,
		(interaction: InteractionDto) => {
			// An agent-initiated pickup is an explicit action, so the voicemail
			// should become the open interaction even when another interaction
			// (e.g. an email) is already active. Record it as the accepted
			// interaction so updateCurrentInteraction selects it for the detail
			// view (see handleInteractionAccepted in useInteractions.ts, which
			// deliberately withholds CurrentInteractionId for this case and lets
			// AcceptedInteractionId drive selection instead).
			// A transferred voicemail is NOT agent-initiated: it can land while
			// the agent is mid-email, so it must not steal focus.
			if (!interaction.wasTransferred) {
				appStoreActions.setCache(CacheKey.AcceptedInteractionId, interaction.id);
			}

			if (interaction.wasTransferred) {
				showMessage("global", {
					intent: "info",
					text: intl.formatMessage({ id: "Interaction.Voicemails.TransferredToYou" }),
				});
			}

			setSelectedTab(TabType.Interactions);
		}
	);
};
